import moment from "moment";
import { useEffect, useState } from "react";
import styled from "styled-components";

import TimePicker from "../../../components/TimePicker";

const TimeRangeContainer = styled.div`
  display: grid;
  grid-template-columns: 45% 5% 45%;
  justify-content: space-between;
  align-items: center;
  gap:8px;
`;
const DashDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const TimeDash = styled.div`
  width: 8px;
  height: 1px;
  background: ${({ theme }) => theme.colors.main.textSecondary};
`;
const TimePickerError = styled.div`
  min-width: 210px;
  position: absolute;
  font-size: 11px;
  top: 44px;
  color: ${({ theme }) => theme.colors.main.error};
`;

const TimeRangeComponent = ({
  setStartTime,
  setEndTime,
  initialStartTime,
  initialEndTime,
  startTimeError,
  endTimeError,
  lastHour,
}) => {
  const [startValue, setStartValue] = useState(
    lastHour
      ? moment().subtract(1, "hour").format("HH:mm")
      : moment().add(10, "minute").format("HH:mm"),
  );
  const [endValue, setEndValue] = useState(
    lastHour
      ? moment().format("HH:mm")
      : moment().add(70, "minute").format("HH:mm"),
  );
  const [startError, setStartError] = useState(false);
  const [endError, setEndError] = useState(false);
  const [focusEnd, setFocusEnd] = useState(false);

  useEffect(() => {
    if (!lastHour) {
      const roundedMinsStartTime = Math.ceil(moment().minutes() / 5) * 5;
      const roundedMinsEndTime = Math.ceil(moment().minutes() / 5) * 5;

      const newStartTime = moment().minutes(roundedMinsStartTime + 10);
      const newEndTime = moment().minutes(roundedMinsEndTime + 70);

      setStartValue(newStartTime.format("HH:mm"));
      setEndValue(newEndTime.format("HH:mm"));
    }
  }, []);

  useEffect(() => {
    if (initialStartTime && initialStartTime !== "") {
      setStartValue(initialStartTime);
    }
  }, [initialStartTime]);

  useEffect(() => {
    if (initialEndTime && initialEndTime !== "") {
      setEndValue(initialEndTime);
    }
  }, [initialEndTime]);

  const onStartChange = value => {
    setStartValue(value);
    setStartTime(value);
  };

  const onEndChange = value => {
    setEndValue(value);
    setEndTime(value);
  };

  const onStartBlur = () => {
    setFocusEnd(true);
  };
  return (
    <TimeRangeContainer style={{ position: "relative" }}>
      {/* <TimePickerInput
        type="text"
        value={startValue}
        onChange={(e) => onStartChange(e)}
        onBlur={() => onStartBlur()}
        placeholder="Start Time"
        error={startError}
      /> */}
      <TimePicker
        hour12Format
        value={startValue}
        onChange={value => onStartChange(value)}
        onFinishInput={onStartBlur}
        error={startTimeError}
      />
      <DashDiv>
        <TimeDash />
      </DashDiv>
      <TimePicker
        hour12Format
        value={endValue}
        onChange={value => onEndChange(value)}
        focusInput={focusEnd}
        setFocusInput={setFocusEnd}
        error={endTimeError}
      />
      {(startError || endError) && (
        <TimePickerError>
          Please enter a valid time. (e.g: 09:00 am)
        </TimePickerError>
      )}
    </TimeRangeContainer>
  );
};

export default TimeRangeComponent;
